import { render, staticRenderFns } from "./SendDatetimeConfiguration.vue?vue&type=template&id=1f606cc2&scoped=true"
import script from "./SendDatetimeConfiguration.vue?vue&type=script&lang=js"
export * from "./SendDatetimeConfiguration.vue?vue&type=script&lang=js"
import style0 from "./SendDatetimeConfiguration.vue?vue&type=style&index=0&id=1f606cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f606cc2",
  null
  
)

export default component.exports